import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import TextField from "../Utils/TextField"
import { useFormik } from "formik"
import { getFormErrorMessage } from "../Utils/formikAux"
import DropdownField from "../Utils/DropdownField"
import styles from "../../../styles/Participant-Employment.module.css"
import PhoneField from "../Utils/PhoneField"
import CheckboxField from "../Utils/CheckboxField"
import { typeOfContacts } from "../Types/Dropdowns"
import { useEffect } from "react"
import { validateEmail } from "../Utils/Utils"

const ContactForm = ({
  visible,
  setVisible,
  edit,
  setValue,
  contacts,
  setEdit,
}) => {
  const { v4: uuidv4 } = require("uuid")
  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
      phone: "",
      primary_phone: false,
      contact_phone: false,
      contact_text: false,
      contact_voicemail: false,
      email: "",
    },
    validate: (data) => {
      let errors = {}
      if (data?.phone?.length < 2) {
        errors.phone = "Phone is required"
      }
      if (data.email) {
        if (!validateEmail(data.email)) {
          errors.email = "Invalid email address"
        }
      }
      return errors
    },
    onSubmit: (data) => {
      data && saveContact(data)
      formik.resetForm()
      setVisible(false)
    },
  })
  useEffect(() => {
    if (edit) {
      formik.setValues({
        name: edit?.name,
        type: edit?.type,
        phone: edit?.phone,
        primary_phone: edit?.primary_phone,
        contact_phone: edit?.contact_phone,
        contact_text: edit?.contact_text,
        contact_voicemail: edit?.contact_voicemail,
        email: edit?.email,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit])
  const footer = () => {
    return (
      <div className={styles.education_form_footer}>
        <Button
          label="Cancel"
          type="button"
          onClick={() => {
            formik.resetForm()
            formik.setErrors({})
            setEdit(null)
            setVisible(false)
          }}
          className={`${styles.button} ${styles.button_secondary}`}
        />
        <Button
          label={`${edit ? "Edit" : "Create"} contact`}
          type="submit"
          style={{ marginLeft: "1rem" }}
          className={`${styles.button}`}
        />
      </div>
    )
  }
  const saveContact = (contact) => {
    const cont = { ...contact, id: uuidv4(), new: true }
    if (edit) {
      const newSave = contacts?.map((s) => {
        let newValue = { ...s }
        if (s.id === edit?.id) {
          newValue.name = cont.name
          newValue.type = cont.type
          newValue.phone = cont.phone
          newValue.primary_phone = cont.primary_phone
          newValue.contact_phone = cont.contact_phone
          newValue.contact_text = cont.contact_text
          newValue.contact_voicemail = cont.contact_voicemail
          newValue.email = cont.email
        }
        return newValue
      })
      setValue("networking_contacts", newSave)
      setEdit(null)
    } else {
      setValue("networking_contacts", [cont, ...contacts])
    }
  }
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "solid 3px #e7e0f1",
          marginBottom: "20px",
        }}
      >
        <p
          style={{
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "33px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >{`${edit ? "Edit" : "Add"} contact`}</p>
        <Button
          className={styles.rounded_btn}
          icon="pi pi-times"
          type="button"
          onClick={() => {
            formik.resetForm()
            setVisible(false)
            setEdit(null)
          }}
          style={{ marginTop: "10px" }}
        />
      </div>
    )
  }
  return (
    <Dialog
      visible={visible}
      style={{ width: "50vw" }}
      onHide={() => {
        formik.resetForm()
        formik.setErrors({})
        setEdit(null)
        setVisible(false)
      }}
      showHeader={false}
    >
      {header()}
      <form onSubmit={formik.handleSubmit}>
        <TextField
          label={"Name"}
          value={formik.values.name}
          setValue={formik.setFieldValue}
          valueName={"name"}
          error={getFormErrorMessage("name", formik)}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            gap: "15px",
            marginTop: "15px",
          }}
        >
          <DropdownField
            label={"Type of contact"}
            options={typeOfContacts}
            value={formik.values.type}
            setValue={formik.setFieldValue}
            valueName={"type"}
            error={getFormErrorMessage("type", formik)}
            size={"50"}
          />
          <div style={{ width: "50%" }}>
            <PhoneField
              label={"Phone Number"}
              required
              error={getFormErrorMessage("phone", formik)}
              value={formik.values.phone}
              setValue={formik.setFieldValue}
              valueName={"phone"}
              style={{ width: "100%" }}
              lblStyle={{ marginTop: "0px", marginBottom: "6px" }}
            />
            <div style={{ marginTop: "1rem" }}>
              <CheckboxField
                label={"Primary phone number"}
                value={formik.values.primary_phone}
                setValue={formik.setFieldValue}
                valueName={"primary_phone"}
                single
              />
            </div>
          </div>
        </div>
        <label className={styles.view_subtitle}>
          Preferences for this phone number
        </label>
        <hr className={styles.line} style={{ marginTop: "10px" }}></hr>
        <div style={{ display: "flex", justifyContent: "start", gap: "15px" }}>
          <CheckboxField
            label={"Okay to contact via phone"}
            value={formik.values.contact_phone}
            setValue={formik.setFieldValue}
            valueName={"contact_phone"}
            single
            style={{ width: "100%" }}
          />
          <CheckboxField
            label={"Okay to text"}
            value={formik.values.contact_text}
            setValue={formik.setFieldValue}
            valueName={"contact_text"}
            single
            style={{ width: "100%" }}
          />
          <CheckboxField
            label={"Okay to leave voicemail"}
            value={formik.values.contact_voicemail}
            setValue={formik.setFieldValue}
            valueName={"contact_voicemail"}
            single
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <TextField
            label={"Email"}
            value={formik.values.email}
            setValue={formik.setFieldValue}
            valueName={"email"}
            error={getFormErrorMessage("email", formik)}
          />
        </div>
        {footer()}
      </form>
    </Dialog>
  )
}
export default ContactForm
